import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";

const SPECIALTIES = ["ICU", "ER", "Med-Surg", "OR", "Cath Lab", "Respiratory Therapy", "Physical Therapy", "Radiology"];
const CATEGORIES = ["Travel", "Local", "Per diem", "Contract", "Permanent"];

export default function PostJob() {
  const nav = useNavigate();
  const [form, setForm] = useState({
    title: "Travel ICU RN — Houston, TX", category: "Travel", specialty: "ICU",
    city: "Houston", state: "TX", pay_rate_min: 65, pay_rate_max: 95, shift: "Night",
    contract_length_weeks: 13, description: "Seeking experienced ICU RN for 13-week travel assignment with top-of-market pay and housing stipend.",
    requirements: "Active RN license, BLS, ACLS, 2+ years ICU experience",
  });
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/jobs", {
        ...form,
        pay_rate_min: Number(form.pay_rate_min),
        pay_rate_max: Number(form.pay_rate_max),
        contract_length_weeks: form.contract_length_weeks ? Number(form.contract_length_weeks) : null,
        requirements: form.requirements.split(",").map((r) => r.trim()).filter(Boolean),
      });
      toast.success("Job posted");
      nav("/dashboard/jobs");
    } catch (e2) { toast.error(formatApiError(e2)); } finally { setLoading(false); }
  };

  return (
    <div className="max-w-3xl space-y-6" data-testid="post-job-page">
      <div>
        <div className="overline text-trital-red">Opportunities</div>
        <h1 className="mt-1 font-display font-black text-3xl lg:text-4xl text-slate-900 tracking-tight">Post Job</h1>
      </div>
      <form onSubmit={submit} className="rounded-2xl bg-white border border-slate-200 p-6 shadow-card grid md:grid-cols-2 gap-4">
        <F label="Title" value={form.title} onChange={upd("title")} span testid="post-job-title" />
        <Sel label="Category" value={form.category} onChange={upd("category")} options={CATEGORIES} />
        <Sel label="Specialty" value={form.specialty} onChange={upd("specialty")} options={SPECIALTIES} />
        <F label="City" value={form.city} onChange={upd("city")} />
        <F label="State" value={form.state} onChange={upd("state")} />
        <F label="Pay min ($/hr)" type="number" value={form.pay_rate_min} onChange={upd("pay_rate_min")} />
        <F label="Pay max ($/hr)" type="number" value={form.pay_rate_max} onChange={upd("pay_rate_max")} />
        <Sel label="Shift" value={form.shift} onChange={upd("shift")} options={["Day", "Night", "Evening", "Rotating"]} />
        <F label="Contract length (weeks, optional)" type="number" value={form.contract_length_weeks} onChange={upd("contract_length_weeks")} />
        <div className="md:col-span-2">
          <L>Description</L>
          <textarea rows={4} value={form.description} onChange={upd("description")} className="mt-1 w-full px-4 py-3 rounded-xl border border-slate-300"></textarea>
        </div>
        <F label="Requirements (comma-separated)" value={form.requirements} onChange={upd("requirements")} span />
        <div className="md:col-span-2">
          <button disabled={loading} className="px-5 py-3 rounded-full bg-trital-navy text-white font-semibold btn-lift hover:bg-trital-navy-deep disabled:opacity-60" data-testid="post-job-submit">{loading ? "Posting…" : "Post job"}</button>
        </div>
      </form>
    </div>
  );
}
const L = ({ children }) => <label className="text-xs font-bold uppercase tracking-wider text-slate-600">{children}</label>;
const F = ({ label, type = "text", value, onChange, span, testid }) => (
  <div className={span ? "md:col-span-2" : ""}>
    <L>{label}</L>
    <input type={type} value={value} onChange={onChange} className="mt-1 w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-trital-navy/30 focus:border-trital-navy outline-none" data-testid={testid} />
  </div>
);
const Sel = ({ label, value, onChange, options }) => (
  <div>
    <L>{label}</L>
    <select value={value} onChange={onChange} className="mt-1 w-full px-4 py-3 rounded-xl border border-slate-300">
      {options.map((o) => <option key={o}>{o}</option>)}
    </select>
  </div>
);
